import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import classnames from 'classnames';
import { isNullOrEmpty } from '../../../../utils/core';

/**
 * @description The draggable element that appears on the Flow canvas to represent functional map elements  
 */
const StandardElement = ({ startDrag, onSelect, isSelected, isDragging, styles, onDelete, ports, developerName, onDoubleClick, actionText }) => (
    <g onDoubleClick={onDoubleClick}>
        {(isSelected) && !isDragging && <rect {...styles.outBorder} className="map-element-hover-out" />}
        <rect {...styles.border} className="map-element-border" />
        <rect {...styles.fill} className="map-element-fill" />
        {
            (isSelected) && !isDragging && onDelete && (
                <foreignObject {...styles.deleteIcon}>
                    <span className="map-element-delete-background" />
                    <Glyphicon
                        onClick={onDelete}
                        className="map-element-delete"
                        glyph={styles.deleteIcon.image}
                    />
                </foreignObject>
            )
        }
        {!isDragging && ports}
        <foreignObject {...styles.content} onMouseDown={startDrag} onMouseUp={onSelect}>
            <span className="map-element-content">
                <Glyphicon className={classnames({ 'map-element-icon': true, 'map-element-no-actions': isNullOrEmpty(actionText) })} glyph={styles.icon} />
                <span className="map-element-text">
                    <span className={classnames({ 'map-element-developer-name': true, 'map-element-no-actions': isNullOrEmpty(actionText) })} title={developerName}>{ developerName }</span>
                    { actionText ? <span className="map-element-description">{actionText}</span> : null }
                </span>
            </span>
        </foreignObject> 
    </g>
);

export default StandardElement;
